import { render } from "./AnimatedIcon.vue?vue&type=template&id=42006fa9"
import script from "./AnimatedIcon.vue?vue&type=script&lang=ts"
export * from "./AnimatedIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script